module.exports = __webpack_public_path__ + "img/1520425229.813a7b89.jpg";